import { Col, Row } from "antd";
import Image from "next/image";
import { Container } from "./styled";

export default function Gallery({ images }) {
  return (
    <Container>
      <Row gutter={16}>
        {images.map((image) => (
          <Col xs={8} key={image.id}>
            <Image alt="Gallery Image" {...image} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
